import React from "react"
import makeStyles from "@material-ui/core/styles/makeStyles"
import {
  Link as MuiLink,
  Box,
  FormControlLabel,
  Checkbox,
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  Typography,
} from "@material-ui/core"

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: 450,
    margin: "auto",
    padding: theme.spacing(2),
  },
  dialogTitle: {
    fontSize: "inherit",
    fontWeight: 900,
  },
  form: {
    maxWidth: 526,
    maxHeight: 716,
    borderRadius: "8px",
    background: "rgba(255,255,255, 0.8)",
    margin: "auto",
    boxShadow: theme.shadows[4],
    color: theme.palette.text.primary,
    "& label": {
      color: theme.palette.text.primary,
      borderLine: 0.5,
    },
    [theme.breakpoints.down(700)]: {
      height: "auto",
    },
  },
  messageLabel: {
    textAlign: "start",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  padding: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  checked: {
    color: theme.palette.text.primary,
  },
  button: {
    borderRadius: theme.spacing(1),
    color: theme.palette.text.secondary,
    backgroundColor: "purple",
    height: "6em",
    "&:hover": {
      backgroundColor: theme.palette.text.primary,
    },
  },
  Box: {
    display: "flex",
    justifyContent: "space-between",
  },
  disclaimer: {
    fontSize: "1em",
  },
  a: {
    color: "purple",
  },
  alignLeft: {
    textAlign: "left",
  },
}))

const Form = () => {
  const classes = useStyles()

  const [state, setState] = React.useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      open: false,
      values: {
        email: "",
        firstname: "",
        lastname: "",
        message: "",
        tel: "",
        promo: false,
      },
    }
  )

  const ContactForm = React.useRef()

  //  React.useEffect(() => {
  //   ContactForm.current = React.createRef()
  //  })

  const handleChange = event => {
    const id = event.target.id
    setState({
      values: {
        ...state.values,
        [id]: event.target.value,
      },
    })
  }

  const clearState = () => {
    setState({
      values: {
        email: "",
        firstname: "",
        lastname: "",
        message: "",
        tel: "",
        promo: false,
      },
    })
  }
  const handleClickOpen = () => {
    setState({ open: true })
  }

  const handleClose = () => {
    setState({ open: false })
  }

  const handleSubmit = event => {
    event.preventDefault()

    // console.log("state: ", state)

    // const form = ContactForm.current

    // fetch("/", {
    //   method: "POST",
    //   headers: { "Content-Type": "application/x-www-form-urlencoded" },
    //   body: encode({
    //     "form-name": form.getAttribute("name"),
    //     ...state.values,
    //   }),
    // })
    //   .then(clearState)
    //   .then(handleClickOpen)
    //   .catch(error => console.log(error))

    let subject, body
    subject = encodeURIComponent(
      "Service Inquiries from " +
        state.values.firstname +
        " " +
        state.values.lastname
    )
    body = encodeURIComponent(composeEmailBody(state.values))
    sendEmail(subject, body)
    clearState()
    handleClickOpen()
  }
  /**
   *
   * @param {*} email
   * @param {*} firstname
   * @param {*} lastname
   * @param {*} message
   * @param {*} tel
   * @param {*} promo
   * @return string
   */
  function composeEmailBody(data) {
    return `
Email: ${data.email}
Name: ${data.firstname} ${data.lastname}
Promotional emails: ${data.promo ? "Yes" : "No"} 
Phone: ${data.tel && data.tel}
    
${data.message}
    
`
  }
  function sendEmail(subject, body) {
    window.location.href = `mailto:glooneevents@gmail.com?subject=${subject}&body=${body}`
  }
  // const encode = data => {
  //   return Object.keys(data)
  //     .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
  //     .join("&")
  // }

  return (
    <Box id="contact-form" className={classes.root}>
      <Dialog
        open={state.open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle
          disableTypography
          id="alert-dialog-slide-title"
          className={classes.dialogTitle}
        >
          Redirected to personal email client
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            color="textPrimary"
          >
            Thanks for writing to us. If your inquiry is urgent, please use the
            telephone number listed below to talk to us. Otherwise, we'll reply
            by email as soon as possible.
          </DialogContentText>
          <DialogContentText color="textPrimary">
            Talk to you soon,
          </DialogContentText>
          <DialogContentText color="textPrimary">
            Gloone Events
          </DialogContentText>
          <DialogContentText gutterBottom color="textPrimary">
            <MuiLink
              href="tel:+234-813-937-7764"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Make a direct call to Gloone"
              underline="always"
            >
              +234-813-917-8642
            </MuiLink>
          </DialogContentText>
          <DialogContentText color="textPrimary">Email</DialogContentText>
          <DialogContentText color="textPrimary">
            <MuiLink
              href="mailto:&#103;&#108;&#111;&#111;&#110;&#101;&#101;&#118;&#101;&#110;&#116;&#115;&#064;&#103;&#109;&#097;&#105;&#108;&#046;&#099;&#111;&#109;"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Send mail"
              underline="always"
            >
              &#103;&#108;&#111;&#111;&#110;&#101;&#101;&#118;&#101;&#110;&#116;&#115;&#064;&#103;&#109;&#097;&#105;&#108;&#046;&#099;&#111;&#109;
            </MuiLink>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} fullWidth>
            close
          </Button>
        </DialogActions>
      </Dialog>

      <form
        ref={ContactForm}
        name="Contact Form"
        method="POST"
        onSubmit={handleSubmit}
        className={classes.form}
      >
        <Box p={3} pt={5} pb={1} className={classes.Box}>
          <TextField
            required
            onChange={handleChange}
            id="firstname"
            name="firstname"
            label="Firstname"
            value={state.values["firstname"]}
          />
          <TextField
            required
            onChange={handleChange}
            id="lastname"
            name="lastname"
            label="Lastname"
            value={state.values["lastname"]}
          />
        </Box>
        <Box p={3} pt={1} pb={1}>
          <TextField
            required
            fullWidth
            onChange={handleChange}
            id="email"
            name="email"
            label="Email"
            type="email"
            value={state.values["email"]}
          />
        </Box>
        <Box p={3} pt={1} pb={1}>
          <TextField
            fullWidth
            onChange={handleChange}
            id="tel"
            name="tel"
            label="Phone Number"
            value={state.values["tel"]}
          />
        </Box>
        <Box p={3}>
          <TextField
            fullWidth
            required
            onChange={handleChange}
            name="message"
            id="message"
            label="Message"
            multiline
            rowsMax={4}
            variant="outlined"
            value={state.values["message"]}
          />
        </Box>
        <Box p={3} pt={0} pb={0} className={classes.alignLeft}>
          <FormControlLabel
            control={
              <Checkbox
                checked={state.promo}
                onChange={handleChange}
                name="checkedB"
                id="checkedB"
                className={classes.checked}
              />
            }
            label="send me promotional emails"
          />
        </Box>
        <Box p={3} pt={1}>
          <Button
            className={classes.button}
            fullWidth
            variant="contained"
            type="submit"
          >
            Get Your Quote
          </Button>
        </Box>
        <Box p={3} pt={1} pb={5} className={classes.alignLeft}>
          <Typography className={classes.disclaimer}>
            By clicking "get quote" you agree to our{" "}
            <MuiLink href="/tos" className={classes.a}>
              <em>term of service</em>
            </MuiLink>{" "}
            and{" "}
            <MuiLink href="/policy" className={classes.a}>
              <em>policy</em>
            </MuiLink>{" "}
            statement.
          </Typography>
        </Box>
      </form>
    </Box>
  )
}

export default Form
